import { render } from "./ForkAndKnifeIcon.vue?vue&type=template&id=85f635d2"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ForkAndKnifeIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85f635d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85f635d2', __exports__)) {
    api.reload('85f635d2', __exports__)
  }
  
  module.hot.accept("./ForkAndKnifeIcon.vue?vue&type=template&id=85f635d2", () => {
    api.rerender('85f635d2', render)
  })

}


export default __exports__